import React from 'react';
import './Portfolio.css';

const Portfolio = ({ setActiveTab }) => {
    // Sample transaction history data
    const transactionHistory = [
        { id: 1, type: 'deposit', amount: 150.00, date: '2024-01-15', status: 'completed', coin: 'USDT', chain: 'BSC' },
        { id: 2, type: 'withdraw', amount: 50.00, date: '2024-01-14', status: 'completed', coin: 'USDC', chain: 'Ethereum' },
        { id: 3, type: 'deposit', amount: 200.00, date: '2024-01-12', status: 'completed', coin: 'USDT', chain: 'BSC' },
        { id: 4, type: 'withdraw', amount: 75.13, date: '2024-01-10', status: 'completed', coin: 'USDT', chain: 'BSC' },
        { id: 5, type: 'deposit', amount: 100.00, date: '2024-01-08', status: 'completed', coin: 'ETH', chain: 'Ethereum' },
    ];

    return (
        <div className="portfolio-card">
            <div className="portfolio-header">
                <h2>Portfolio</h2>
                <p className="portfolio-subtitle">Your account balance</p>
            </div>

            <div className="balance-display">
                <span className="currency-symbol">$</span>
                <span className="balance-amount">376.87</span>
            </div>

            <div className="portfolio-actions">
                <button className="action-btn deposit-btn" onClick={() => setActiveTab('deposit')}>
                    <svg viewBox="0 0 24 24" width="20" height="20">
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                    </svg>
                    Deposit
                </button>
                <button className="action-btn withdraw-btn">
                    <svg viewBox="0 0 24 24" width="20" height="20">
                        <path d="M19 13H5v-2h14v2z" />
                    </svg>
                    Withdraw
                </button>
            </div>

            <div className="portfolio-info">
                <div className="info-row">
                    <span className="info-label">Available Balance</span>
                    <span className="info-value">$376.87</span>
                </div>
                <div className="info-row">
                    <span className="info-label">Pending</span>
                    <span className="info-value">$0.00</span>
                </div>
            </div>

            <div className="transaction-history">
                <h3 className="history-title">Recent Transactions</h3>
                <div className="history-list">
                    {transactionHistory.map((transaction) => (
                        <div key={transaction.id} className="history-item">
                            <div className="history-icon">
                                {transaction.type === 'deposit' ? (
                                    <svg viewBox="0 0 24 24" width="20" height="20" className="deposit-icon">
                                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 24 24" width="20" height="20" className="withdraw-icon">
                                        <path d="M19 13H5v-2h14v2z" />
                                    </svg>
                                )}
                            </div>
                            <div className="history-info">
                                <div className="history-type">
                                    {transaction.type === 'deposit' ? 'Deposit' : 'Withdraw'}
                                    <span className="history-coin"> · {transaction.coin} ({transaction.chain})</span>
                                </div>
                                <div className="history-date">{transaction.date}</div>
                            </div>
                            <div className="history-amount">
                                <span className={transaction.type === 'deposit' ? 'amount-positive' : 'amount-negative'}>
                                    {transaction.type === 'deposit' ? '+' : '-'}${transaction.amount.toFixed(2)}
                                </span>
                                <div className="history-status">{transaction.status}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Portfolio;